import { render, staticRenderFns } from "./PartNumberForm.vue?vue&type=template&id=4522102e"
import script from "./PartNumberForm.vue?vue&type=script&lang=js"
export * from "./PartNumberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports